export const TERRA_INVOCATION_ROUTING_BUNDLE_CACHE_KEY_PREFIX =
  'terra-invocation-routing-rules-bundle';

export const TERRA_INVOCATION_ROUTING_CACHE_KEY_PREFIX =
  'terra-invocation-routing-rules';

export const TERRA_EMBEDDING_ROUTING_BUNDLE_CACHE_KEY_PREFIX =
  'terra-embedding-routing-rules-bundle';

export const TENANT_MODEL_ROUTER_CACHE_TTL_SECONDS = 48 * 60 * 60;

type TenantBedrockRoutingScope = 'in-region' | 'global' | 'us' | 'eu';

export const TENANT_BEDROCK_ROUTING_SCOPES: readonly TenantBedrockRoutingScope[] =
  ['in-region', 'global', 'us', 'eu'];

type TenantReasoningEffort = 'low' | 'medium' | 'high' | 'xhigh' | 'max';

export const TENANT_REASONING_EFFORTS: readonly TenantReasoningEffort[] = [
  'low',
  'medium',
  'high',
  'xhigh',
  'max',
];

type TenantReasoningSetting = 'off' | TenantReasoningEffort;

export const TENANT_REASONING_SETTINGS: readonly TenantReasoningSetting[] = [
  'off',
  ...TENANT_REASONING_EFFORTS,
];

export const buildTerraInvocationRoutingBundleCacheKey = (): string =>
  TERRA_INVOCATION_ROUTING_BUNDLE_CACHE_KEY_PREFIX;

export const buildTerraInvocationRoutingCacheKey = ({
  invocation,
}: {
  invocation: string;
}): string => `${TERRA_INVOCATION_ROUTING_CACHE_KEY_PREFIX}:${invocation}`;

export const buildTerraInvocationRoutingCacheKeyPattern = (): string =>
  `${TERRA_INVOCATION_ROUTING_CACHE_KEY_PREFIX}:*`;

export const buildTerraEmbeddingRoutingBundleCacheKey = (): string =>
  TERRA_EMBEDDING_ROUTING_BUNDLE_CACHE_KEY_PREFIX;
